import { RestQueryHookOptions, RestQueryHookResult, useRestQuery } from 'utils/hooks/api';
import { SpamClassification } from '../common/constants';

const SPAM_REPORT_RESPONSE_URL = '/i/templates/spamResults?templateId=';

export interface SpamReport {
  filter: string;
  typeOfFilter: string;
  classification: SpamClassification;
}

export const useGetSpamReportQuery = (
  templateId?: number,
  options?: RestQueryHookOptions,
): RestQueryHookResult<SpamReport[]> => {
  const url = `${SPAM_REPORT_RESPONSE_URL}${templateId}`;
  return useRestQuery<SpamReport[]>(url, {}, options);
};
